module.exports = __webpack_public_path__ + "a8a10a3e/img/dollar-icon.35c9d638.svg";